import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M29.732 6.708a1.6 1.6 0 0 0-1.117-1.149 1.6 1.6 0 0 0-1.562.41L23.311 9.71l-2.593-.431-.432-2.593 3.742-3.742a1.597 1.597 0 0 0-.747-2.68 8.8 8.8 0 0 0-8.39 2.33c-2.217 2.22-3.059 5.422-2.263 8.48L1.3 22.4a4.46 4.46 0 0 0 0 6.296C2.141 29.536 3.26 30 4.45 30s2.307-.463 3.147-1.304L18.914 17.38c3.048.804 6.257-.043 8.49-2.275a8.78 8.78 0 0 0 2.328-8.398Zm-3.654 7.073c-1.868 1.864-4.596 2.498-7.135 1.654l-.55-.184L6.271 27.37c-.973.973-2.67.973-3.645 0a2.584 2.584 0 0 1 0-3.646l12.13-12.128-.181-.547c-.839-2.546-.209-5.277 1.642-7.129a6.91 6.91 0 0 1 6.124-1.94L18.28 6.045l.809 4.864 4.867.81 4.06-4.064a6.92 6.92 0 0 1-1.938 6.126M4.688 24.375a.937.937 0 1 0 0 1.874.937.937 0 0 0 0-1.874"
    }, null, -1)
  ])))
}
export default { render: render }